import { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../utils/Loader";
import { showModal } from "../../redux/actions/ModalActions";
import ModalManager from "../../Modals/ModalManager";
import * as qs from "qs"
import { falseStatus } from "../../redux/actions/ChangedAction";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import { hideLoader, showLoader } from "../../redux/actions/LoaderActions";
import ApiServices from "../../config/ApiServices";
import { Link } from "react-router-dom";

export default function ManageBatches({title}){
   const dispatch=useDispatch()
   const loading=useSelector((state)=>state.loader.loading)
   const isOpen=useSelector((state)=>state.modal.isOpen)
   const [status,setStatus]=useState(true)
   const [batches,setBatches]=useState([])

    useEffect(()=>{
        if(!isOpen){
            fetchBatch()
        }
    },[status, isOpen])

    const userId=sessionStorage.getItem("userId")

    const fetchBatch=()=>{
        dispatch(showLoader())
        ApiServices.apiRequest("getBatch",{trainerId:userId, status:status})
        .then((result)=>{
            if(result.data.success){
                setBatches(result.data.data)
            }
        })
        .catch((err)=>{
            console.log(err);
        })
        .finally(()=>{
            dispatch(hideLoader())
        })
    }

    const changeStatusBatch = (batchId, batchStatus) => {
    const msg = batchStatus ? "removeBatch" : "addBackBatch";
    let data = {
        _id: batchId,
        status: !batchStatus
    };
    
    dispatch(showModal("StatusModal", data, "changeStatusBatch", msg));
};


    const leaveClass=(batchId)=>{
        let data={
            batchId:batchId,
            trainerId:userId
        }
        dispatch(showModal("StatusModal",qs.stringify(data),"removeTrainer","leaveClass"))
    }

    const handleStatusChange = (event) => {
        setStatus(JSON.parse(event.target.value)); // Ensure the value is parsed as boolean
    };

    return(
        <>
            <div className="container">
                <div className="page-inner">
                {
                    loading && !isOpen? 
                        <Loader/>
                        :
                        <>
                            <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
                                <div>
                                <h3 className="fw-bold mb-3">{title}</h3>
                                <select className="form-select me-2 " onChange={handleStatusChange} value={status}>
                                    <option value={true}>Current</option>
                                    <option value={false}>Removed</option>
                                </select>
                                </div>
                                <div className="ms-md-auto py-2 py-md-0">
                                    <button onClick={()=>{dispatch(showModal("AddBatch"))}} className="btn btn-primary btn-round">
                                        Create Batch
                                    </button>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row">
                                    {
                                        batches?.length>0?
                                        batches?.map((el,index)=>(
                                            <div className="col-sm-6 text-capitalize col-md-4 col-lg-3 col-12" key={el?._id}>
                                                <Link to={"/trainer/viewBatches/"+el?._id}>
                                                    <div className="card p-3">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <h4 className="">{el?.name}</h4>
                                                            <div className="dropdown">
                                                                <IconButton type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <MoreVertIcon />
                                                                </IconButton>
                                                                <ul className="dropdown-menu">
                                                                    {status ?
                                                                    <li><a className="dropdown-item" href="#" onClick={()=>{
                                                                        changeStatusBatch(el?._id, el?.status)
                                                                    }}>Archive</a></li>
                                                                    : 
                                                                    <li><a className="dropdown-item" href="#" onClick={()=>{
                                                                        changeStatusBatch(el?._id, el?.status)
                                                                    }}>Add Back</a></li>
                                                                }
                                                                {el?.ownerId?._id!=userId &&
                                                                <li><a className="dropdown-item" href="#" onClick={()=>{
                                                                    leaveClass(el?._id)
                                                                }}>Leave</a></li>
                                                                }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div className="">{el?.batchTime}</div>
                                                    </div>
                                                </Link>
                                            </div>
                                        ))
                                        :
                                        <h1>No Batch Found!!</h1>
                                    }
                                </div>
                            </div>
                        </>
                }
                </div>
            </div>
        </>
    )
}
